/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        id === open ? "rotate-180" : ""
      } h-4 w-4 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

const itemContent = [
  {
    id: 1,
    title: " Software Development",
    descriptions: ` We provide a high quality custom software by following trending technological advancements and employing the proper tools.`,
  },
  {
    id: 7,
    title: " AI Automation",
    descriptions: `Automation of business processes, streaming workflows and improving decision making by using machine learning, data analysis and intelligent integrations`,
  },
  {
    id: 2,
    title: " ICT Consultancy",
    descriptions: ` We provide a technology consultancy service to help clients transform the way they use technology.`,
  },
  {
    id: 3,
    title: " Network Infrastructure",
    descriptions: ` In collaboration with third party providers we provide network infrastructure installation and configuration services.`,
  },
  {
    id: 4,
    title: " Business Automation",
    descriptions: ` We help businesses improve their efficiency and properly utilize their resources with reduced cost by leveraging technology.`,
  },
  {
    id: 5,
    title: " ERP System Provison",
    descriptions: ` We provide our ERP system which is designed to facilitate and streamline the core operations of a business.`,
  },
  // {
  //   id: 6,
  //   title: " AI Model Training",
  //   descriptions: `  Training proprietary models tailored to specific industries or datasets, ensuring better accuracy and competitive differentiation.`,
  // },
];

const FaqAccordion = () => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <>
      {itemContent.map((item) => (
        <Accordion
          className="accordion-item mb-5 overflow-hidden rounded-lg border border-jacarta-100 dark:border-jacarta-600 h-auto"
          key={item.id}
          open={open === item.id || item.id == 1}
          icon={<Icon id={item.id} open={open} />}
        >
          <AccordionHeader
            className="accordion-button collapsed relative flex w-full items-center justify-between bg-white px-4 py-3 text-left font-display text-sm text-jacarta-700 dark:bg-jacarta-700 dark:text-white"
            onClick={() => handleOpen(item.id)}
          >
            {item.title}
          </AccordionHeader>
          <div className="hidden-style">
            <AccordionBody className="accordion-body border-t border-jacarta-100 bg-white p-4 dark:border-jacarta-600 dark:bg-jacarta-700">
              {item.descriptions}
            </AccordionBody>
          </div>
        </Accordion>
      ))}
    </>
  );
};

export default FaqAccordion;
